// Derives a candidate slug from a skill name, matching the backend's
// required pattern exactly (SkillCreateRequest.slug:
// `^[a-z0-9][a-z0-9-]*$`, src/agenthub/schemas/skills.py). The form seeds
// the editable slug field with this and lets the user adjust it (e.g. to
// resolve a "slug already in use" conflict).

export function deriveSlug(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
